import { CascadiaColor } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import { AriaProgressBarProps, useProgressBar } from "react-aria";

import { Text, useColors } from "@certn/cascadia-react";

import { FormLabel } from "../../inputs/_assets/input-wrapper/FormLabel";
export interface ProgressLoaderProps extends AriaProgressBarProps {
  floating?: boolean;
  color?: CascadiaColor;
  testID?: string;
  size?: "small" | "large";
}

export function ProgressLoader(props: ProgressLoaderProps) {
  const {
    value = 0,
    minValue = 0,
    maxValue = 100,
    floating = false,
    color = "background-accent-green-strong",
    label,
    valueLabel = !!label,
    testID = "progress-loader",
    size,
  } = props;
  const colors = useColors();
  const height = size === "small" ? "var(--space-1-5)" : "var(--space-2)";
  const percentage = (value - minValue) / (maxValue - minValue);
  const barWidth = `${Math.round(percentage * 100)}%`;
  const { progressBarProps, labelProps } = useProgressBar({
    ...props,
    "aria-label": props["aria-label"] || !label ? "Loading..." : undefined,
  });

  return (
    <div {...progressBarProps} data-testid={testID}>
      {(label || valueLabel) && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <FormLabel {...labelProps} isRequired>
            {label}
          </FormLabel>
          <Text>{progressBarProps["aria-valuetext"]}</Text>
        </div>
      )}
      <div
        className={css(styles.wrapper, {
          height,
          background: "var(--background-selected-weak)",
          borderRadius: floating ? "var(--border-radius-3)" : "",
        })}
      >
        <div
          className={css(
            styles.filler,
            {
              height,
              width: barWidth,
            },
            {
              backgroundColor: colors[color],
              borderRadius: floating ? "var(--border-radius-3)" : "",
            }
          )}
        />
      </div>
    </div>
  );
}

const styles = {
  wrapper: css({
    width: "100%",
  }),
  filler: css({
    transition: "width 200ms",
    textAlign: "right",
  }),
};
